var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuArchivioEsercizi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.32,823.5l-88.31-88.31c-20.05-20.07-20.05-52.59,0-72.65l180.35-180.25c20.07-20.05,52.59-20.05,72.65,0l103.82,103.82,214.27-214.27-103.82-103.82c-20.08-20.07-20.08-52.61-.02-72.68,0,0,.01-.01.02-.02L662.54,15.06c20.07-20.08,52.61-20.08,72.68-.02,0,0,.01.01.02.02l88.26,88.26c32.21-21.46,75.72-12.74,97.18,19.47,15.68,23.53,15.68,54.18,0,77.72l88.31,88.31c20.05,20.07,20.05,52.59,0,72.65l-180.35,180.25c-20.07,20.05-52.59,20.05-72.65,0l-103.82-103.82-214.27,214.27,103.82,103.82c20.08,20.07,20.08,52.61.02,72.68l-.02.02-180.25,180.25c-20.07,20.08-52.61,20.08-72.68.02,0,0-.01-.01-.02-.02l-88.26-88.26c-32.21,21.46-75.72,12.74-97.18-19.47-15.68-23.53-15.68-54.18,0-77.72h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArchivioEsercizi);
export default __webpack_public_path__ + "static/media/menu-archivio-esercizi.f7145b95e201756a61141f5e999f39e8.svg";
export { ForwardRef as ReactComponent };